import { Component } from '@angular/core';

@Component({
  selector: 'app-model-navigator',
  imports: [],
  templateUrl: './model-navigator.component.html',
})
export class ModelNavigatorComponent {

}
